import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

type IconVariant = 'success' | 'error' | 'info' | null;

@Component({
    selector: 'error-popup',
    templateUrl: './error-popup.html',
    styleUrls: ['./error-popup.scss'],
    standalone: false,
})
export class ErrorPopup {
    title: string;
    message: string;
    message1: string;
    message2: string;
    gifUrl: string;
    iconVariant: IconVariant = null;
    iconName: string = '';

    constructor(
        public dialogRef: MatDialogRef<ErrorPopup>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.title = data.title;
        this.message = data.message;
        this.message2 = data.message2;
        this.message1 = data.message1;
        this.gifUrl = './assets/img/success.gif';
        this.resolveIcon(this.title);
    }

    private resolveIcon(title: string | undefined): void {
        const t = (title || '').toLowerCase();
        if (
            t.includes('success') ||
            t.includes('scheduled') ||
            t.includes('edited') ||
            t.includes('congrats') ||
            t.includes('account created') ||
            t.includes('thank you!')
        ) {
            return;
        }
        if (
            t === 'error' ||
            t.includes('error') ||
            t.includes('failed') ||
            t.includes('unable')
        ) {
            this.iconVariant = 'error';
            this.iconName = 'warning-circle';
            return;
        }
        this.iconVariant = 'info';
        this.iconName = 'info-circle';
    }

    isShowGif(title: string | undefined): boolean {
        const t = (title || '').toLowerCase();
        if (
            t.includes('success') ||
            t.includes('activity scheduled') ||
            t.includes('activity edited') ||
            t.includes('congrats') ||
            t.includes('account created')
        ) {
            return true;
        } else {
            return false;
        }
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
